(function () {
  const ZOOM = 2.6;
  const CHART_RE = /color\s*chart/i;

  function isChartModal(node) {
    return !!(
      node &&
      node.closest &&
      node.closest('.tpo_modal-container, .tpo_modal-content, .tpo_modal-background, [class*="tpo_modal"]')
    );
  }

  function isProductGalleryImg(img) {
    if (!img || img.tagName !== 'IMG') return false;
    if (img.closest('.thumbnail-list, .thumbnail-slider, .product__thumbnails')) {
      return false;
    }
    return !!(
      img.closest('.product-media-container.media-type-image .product__media') ||
      img.closest('.product-media-modal__content') ||
      (img.classList.contains('image-magnify-lightbox') &&
        img.closest('.product-media-container, .product-media-modal__content'))
    );
  }

  function zoomImg(target) {
    if (!target || !target.closest) return null;

    // Gallery lightbox toggle sits on top of the image and receives pointer events
    const opener = target.closest(
      '.product__modal-opener--image, .product-media-container.media-type-image'
    );
    if (opener && !isChartModal(opener)) {
      const nested = opener.querySelector('.product__media img, img.image-magnify-lightbox, img');
      if (nested && isProductGalleryImg(nested)) return nested;
    }

    const img = target.tagName === 'IMG' ? target : target.closest('img');
    if (!img) return null;
    if (isChartModal(img)) return img;
    if (isProductGalleryImg(img)) return img;
    return null;
  }

  function addHints() {
    document.querySelectorAll('.uc-chart-hint').forEach((hint) => {
      if (!hint.closest('.tpo_modal-container, [class*="tpo_modal-container"]')) {
        hint.remove();
      }
    });

    const modals = document.querySelectorAll('.tpo_modal-container, [class*="tpo_modal-container"]');
    modals.forEach((modal) => {
      const existing = modal.querySelectorAll('.uc-chart-hint');
      existing.forEach((hint, index) => {
        if (index > 0) hint.remove();
      });

      const heading =
        modal.querySelector('.tpo_modal-heading') ||
        modal.querySelector('h2, h3, [class*="tpo_modal-heading"]');
      if (!heading || !CHART_RE.test(heading.textContent || '')) return;

      const title = heading.querySelector('h3, h2') || heading;

      let hint = modal.querySelector('.uc-chart-hint');
      if (!hint) {
        hint = document.createElement('span');
        hint.className = 'uc-chart-hint';
      }
      hint.innerHTML =
        '<span class="uc-chart-hint__desktop">(e.g., hover over the image to zoom)</span>' +
        '<span class="uc-chart-hint__mobile">(e.g., tap and drag to zoom)</span>';

      if (hint.parentElement !== title) title.appendChild(hint);
    });
  }

  let hintTimer = null;
  function scheduleHints() {
    clearTimeout(hintTimer);
    hintTimer = setTimeout(addHints, 120);
  }

  function pointFromEvent(event) {
    if (event.touches && event.touches[0]) {
      return { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }
    return { x: event.clientX, y: event.clientY };
  }

  function setOrigin(img, event) {
    const rect = img.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const point = pointFromEvent(event);
    const x = ((point.x - rect.left) / rect.width) * 100;
    const y = ((point.y - rect.top) / rect.height) * 100;
    img.style.transformOrigin = x.toFixed(2) + '% ' + y.toFixed(2) + '%';
    img.style.transform = 'scale(' + ZOOM + ')';
  }

  function reset(img) {
    if (!img) return;
    img.style.transform = 'scale(1)';
    img.style.transformOrigin = 'center center';
    img.classList.remove('uc-chart-zoom');
  }

  document.addEventListener(
    'mousemove',
    function (event) {
      const img = zoomImg(event.target);
      if (!img) return;
      setOrigin(img, event);
    },
    { passive: true }
  );

  document.addEventListener(
    'mouseover',
    function (event) {
      const img = zoomImg(event.target);
      if (!img) return;
      img.classList.add('uc-chart-zoom');
      setOrigin(img, event);
    },
    { passive: true }
  );

  document.addEventListener(
    'mouseout',
    function (event) {
      const img = zoomImg(event.target);
      if (!img) return;
      const next = event.relatedTarget;
      if (next && zoomImg(next) === img) return;
      reset(img);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchstart',
    function (event) {
      const img = zoomImg(event.target);
      if (!img) return;
      img.classList.add('uc-chart-zoom');
      setOrigin(img, event);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (event) {
      const img = zoomImg(event.target);
      if (!img) return;
      setOrigin(img, event);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (event) {
      reset(zoomImg(event.target));
    },
    { passive: true }
  );

  document.addEventListener(
    'touchcancel',
    function (event) {
      reset(zoomImg(event.target));
    },
    { passive: true }
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleHints);
  } else {
    scheduleHints();
  }
  document.addEventListener('shopify:section:load', scheduleHints);
  new MutationObserver(scheduleHints).observe(document.documentElement, { childList: true, subtree: true });
})();
